import format from 'date-fns/format';
import { PortProp } from '../components/AvailabilityTable';

const getBoatAvailability = (date?: Date, portObj?: PortProp) => {
    const formatedDate = format(new Date(date!), 'yyyy MM dd');
    const from = portObj?.portCodeFrom ? portObj?.portCodeFrom : 'H';
    const to = portObj?.portCodeTo ? portObj?.portCodeTo : 'T';

    const data = fetch(`https://api.rederij-doeksen.nl/departures/${from}/${to}/availability?date=${formatedDate}`, {
        method: 'GET',
        headers: {
            Authorization: `ApiKey ${process.env.NEXT_PUBLIC_FERRY_TIMES_API_KEY}`,
        },
    }).then(res => res.json());

    return data;
};

export default getBoatAvailability;
